/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class BatchesRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    let schoolId = this.session.activeSchool;

    return hash({
      batches: this.store.query('assessments/batch', { schoolId }),
      // Preloaded so each batch's assessment relationship resolves from the
      // store (for displaying the assessment label) without a fetch per row.
      assessments: this.store.query('assessments/assessment', { schoolId }),
    });
  }
}
